import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { map } from 'ramda';

import config from '../../config';
import { Logo } from '../../components';

import AppSection from './AppSection/AppSection';
import LinkSection from './LinkSection/LinkSection';
import SocialSection from './SocialSection/SocialSection';
import css from './Footer.css';

const Footer = (props) => {
  const { rootClassName, className, intl } = props;
  const brandText = intl.formatMessage({ id: 'Footer.brandText' });
  const newsTitle = intl.formatMessage({ id: 'Footer.news' });
  const helpTitle = intl.formatMessage({ id: 'Footer.help' });
  const followUsTitle = intl.formatMessage({ id: 'Footer.followUs' });
  const downloadAppTitle = intl.formatMessage({ id: 'Footer.downloadApp' });
  const classes = classNames(rootClassName || css.root, className);
  const linkSections = [
    {
      headingText: newsTitle,
      key: 1,
      links: [
        {
          type: 'ExternalLink',
          props: { href: 'https://blog.swimmy.fr/' },
          text: intl.formatMessage({ id: 'Footer.blog' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'PressPage' },
          text: intl.formatMessage({ id: 'Footer.media' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'WhoWeArePage' },
          text: intl.formatMessage({ id: 'Footer.whoWeAre' }),
        },
      ],
    },
    {
      headingText: helpTitle,
      key: 2,
      links: [
        {
          type: 'ExternalLink',
          props: { href: config.custom.helpCenterUrlForCustomers, openInSameWindow: true },
          text: intl.formatMessage({ id: 'Footer.helpCustomer' }),
        },
        {
          type: 'ExternalLink',
          props: { href: config.custom.helpCenterUrlForProviders, openInSameWindow: true },
          text: intl.formatMessage({ id: 'Footer.helpProvider' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'SimulatorPage' },
          text: intl.formatMessage({ id: 'Footer.rent' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'HowItWorksPage' },
          text: intl.formatMessage({ id: 'Footer.howItWorks' }),
        },
        // {
        //   type: 'NamedLink',
        //   props: { name: 'TaxationPage' },
        //   text: intl.formatMessage({ id: 'Footer.taxation' }),
        // },
      ],
    },
    {
      headingText: helpTitle,
      key: 3,
      links: [
        {
          type: 'ExternalLink',
          props: { href: config.custom.helpCenterUrl, openInSameWindow: true },
          text: intl.formatMessage({ id: 'Footer.helpdesk' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'TermsOfServicePage' },
          text: intl.formatMessage({ id: 'Footer.termsOfUse' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'PrivacyPolicyPage' },
          text: intl.formatMessage({ id: 'Footer.privacyPolicyPage' }),
        },
        {
          type: 'NamedLink',
          props: { name: 'LegalNoticePage' },
          text: intl.formatMessage({ id: 'Footer.legalNoticePage' }),
        },
      ],
    },
  ];

  return (
    <div className={classes}>
      <div className={css.brandContainer}>
        <Logo format="desktop" className={css.brandLogo} />
        <span className={css.brandText}>{brandText}</span>
      </div>
      <div className={css.linkContainer}>
        {map(
          (sectionProps) => (
            <LinkSection
              key={sectionProps.key}
              className={css.linkSection}
              headingClassName={css.heading}
              linkClassName={css.link}
              {...sectionProps}
            />
          ),
          linkSections
        )}
        <SocialSection
          className={css.linkSection}
          headingClassName={css.heading}
          linkClassName={css.link}
          headingText={followUsTitle}
          intl={intl}
        />
        <AppSection
          className={css.linkSection}
          headingClassName={css.heading}
          headingText={downloadAppTitle}
        />
      </div>
    </div>
  );
};

Footer.defaultProps = {
  rootClassName: null,
  className: null,
};

Footer.propTypes = {
  rootClassName: string,
  className: string,

  // from injectIntl
  intl: intlShape.isRequired,
};

export default injectIntl(Footer);
